import React from 'react';

import { Filter, useTranslate } from 'react-admin';

import TextInputEx from '../../../components/_extensions/react-admin/input/TextInputEx';

import { DateTimeInput } from '../../../components/inputs';

import { SelectEnumInput } from 'components/inputs/SelectEnumInput';
import { UserRole } from '../../../entities/UserRole';



export const LoginLogsFilter = (props) => {
	const translate = useTranslate()

	return <Filter {...props} >
		<DateTimeInput source='created_at.created_at_from' label={translate('osfc.filters.created_at.from')} withLocalTimeZone />
		<DateTimeInput source='created_at.created_at_to' label={translate('osfc.filters.created_at.to')} withLocalTimeZone />
		<SelectEnumInput enumObj={UserRole} translate={false} source='user_role'/>

	</Filter>
};
